export default function triggerCustomGaEvent(eventName, eventBody) {
  let gaEvent = new CustomEvent(eventName, { detail: eventBody })
  dispatchEvent(gaEvent)
}
